module.exports = __webpack_public_path__ + "static/media/besan.a06ad311.jpg";